import { Box, Button, CircularProgress, Paper, Stack } from '@mui/material'
import SelectorGruposBalance from 'common/components/SelectorGruposBalance'
import CustomerInvoiceDropZone from 'features/invoice_registration/components/CustomerInvoiceDropZone'
import EfacturasVentasList from 'features/invoice_registration/components/EfacturasVentasList'
import { CustomerInvoiceHelper } from 'features/invoice_registration/helpers/CustomerInvoiceHelper'
import useFetchEfacturasVentas from 'features/invoice_registration/hooks/useFetchEfacturasVentas'
import { enqueueSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import i18n from 'src/lang/idiomas'

/**
 * @module CustomersInvoiceRegistration
 */
const CustomersInvoiceRegistration = () => {
  const [ficheros, setFicheros] = useState([])
  const [refetch, setRefetch] = useState(0)
  const [efacturasVentasList, setEfacturasVentasList] = useState([])
  const { response, loading, error } = useFetchEfacturasVentas({ reFetch: refetch })
  const [loader, setLoader] = useState(false)
  const [grupoBalance, setGrupoBalance] = useState('')
  const [errorGrupoBalance, setErrorGrupoBalance] = useState(false)

  useEffect(() => {
    setEfacturasVentasList(response)
  }, [response])

  useEffect(() => {
    if (error) {
      enqueueSnackbar(`Error al cargar las efacturas de ventas`, { variant: 'error' })
    }
  }, [error])

  const clearAllInputHandler = () => {
    setFicheros([])
    setGrupoBalance('')
  }

  const handlerGrupoBalance = (value) => {
    setGrupoBalance(value)
    setErrorGrupoBalance(false)
  }

  const submitHandler = () => {
    if (!grupoBalance) {
      setErrorGrupoBalance(true)
      enqueueSnackbar(
        i18n.t('efactura.errgruba', { defaultValue: 'Se debe seleccionar un grupo de balance' }),
        { variant: 'error' },
      )
      return
    } else {
      setErrorGrupoBalance(false)
    }

    if (!ficheros.length) {
      enqueueSnackbar(
        i18n.t('efactura.errselar', { defaultValue: 'Se debe seleccionar un archivo' }),
        { variant: 'error' },
      )
      return
    }
    setLoader((pre) => !pre)
    CustomerInvoiceHelper.createCustomerInvoice({
      ficheros,
      idioma: '01',
      grupo_balance: grupoBalance,
    })
      .then((res) => {
        enqueueSnackbar(
          i18n.t('efactura.ficsubco', { defaultValue: 'Los ficheros se han subido correctamente' }),
          {
            variant: 'success',
          },
        )
        setRefetch((pre) => pre + 1)
        clearAllInputHandler()
      })
      .catch((err) => {
        enqueueSnackbar(err.message, { variant: 'error' })
      })
      .finally(() => {
        setLoader((pre) => !pre)
      })
  }

  return (
    <Box id="customers-invoice-registration-page">
      <Paper sx={{ p: 4, mb: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <SelectorGruposBalance
            grupoBalance={grupoBalance}
            handleChange={handlerGrupoBalance}
            error={errorGrupoBalance}
          />
          <Box>
            <CustomerInvoiceDropZone
              setFicheros={setFicheros}
              ficheros={ficheros}
              maxFiles={10}
              sx={{ bgcolor: '#FFF' }}
            />
          </Box>
          <Stack direction={'row'} spacing={5}>
            <Button variant="contained" onClick={submitHandler} disabled={loader}>
              {i18n.t('efactura.envfact', { defaultValue: 'Enviar Facturas' })}{' '}
              {loader && <CircularProgress sx={{ position: 'absolute' }} size={20} />}
            </Button>
            <Button variant="contained" onClick={clearAllInputHandler}>
              {i18n.t('general.cancelar', { defaultValue: 'Cancelar' })}
            </Button>
          </Stack>
        </Box>
      </Paper>

      <EfacturasVentasList efacturasVentasList={efacturasVentasList} loading={loading} />
    </Box>
  )
}

export default CustomersInvoiceRegistration
